<template>
    <el-select ref="lifeEventSelect" v-model="modelValue" @change="change($event, chronicle)">
        <el-option v-for="(item, index) in getEventMastersByRelationshipId(member.relationshipId)" :key="index" :label="item.itemValue" :value="item.id"></el-option>
    </el-select>
</template>

<script>
import { isIE } from '@/common/useragent'

export default {
  name: 'lifeEventSelect',
  props: [
    'value',
    'chronicle',
    'changeAction',
    'eventMasters',
    'member'
  ],
  data () {
    return {
      modelValue: this.value
    }
  },
  mounted () {
    if (isIE()) {
      // IEでel-selectのプルダウンにフォーカスするとカーソルが表示される問題を修正
      const $input = this._$(this.$refs.lifeEventSelect.$el.querySelector('input[type="text"]'))
      $input.css('pointer-events', 'none')
      $input.on('focus', event => event.currentTarget.blur())
    }
  },
  methods: {
    change: function ($event, chronicle) {
      this.changeAction($event, chronicle)
      this.$emit('input', this.modelValue)
      this.$emit('change', this.modelValue)
    },
    getEventMastersByRelationshipId (relationshipId) {
        const listEventMaster = this.eventMasters.filter(e => (+e.relationshipId === +relationshipId || e.relationshipId == null))
        const otherEvent = listEventMaster.find(e => e.itemValue === '自由入力')
        if (otherEvent) {
            listEventMaster.push(listEventMaster.splice(listEventMaster.indexOf(otherEvent), 1)[0])
        }
        return listEventMaster
      }
  },
  watch: {
    value () {
      this.modelValue = this.value
    }
  }
}
</script>
